<div style="max-height: 100%">
  <div (keyup.enter)="onOK()" class="flex-column">
    <div class="profile-box info-box flex-column">
      <header class="accent flex-row-space-between-center">
        <div class="modal-title">
          {{ "ASSIGNMENTS.JOB_EXPENSES" | translate }}
        </div>
        <div
          class="gt2-light-green flex-row-center-center"
          style="width: 60px; height: 56px"
        >
          <button
            type="button"
            matTooltip="{{ 'ASSIGNMENTS.ADD_EXPENSE' | translate }}"
            mat-icon-button
            class=""
            (click)="onAddExpense()"
          >
            <mat-icon class="" style="color: black">add</mat-icon>
          </button>
        </div>
      </header>
    </div>

    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      name="expensesSpiner"
      size="medium"
      color="white"
      [fullScreen]="true"
      type="ball-scale-multiple"
    >
    </ngx-spinner>

    <div class="p-12">
      <div class="expenses-list flex-column" fusePerfectScrollbar>
        <div *ngFor="let jobExpense of jobExpenses" class="expense-item">
          <app-job-expenses-item
            [expense]="jobExpense"
            (saveExpense)="onSaveExpense($event)"
            (editExpense)="onEditExpense($event)"
            (deleteExpense)="onDeleteExpense($event)"
          >
          </app-job-expenses-item>
        </div>
        <div
          *ngIf="jobExpenses.length === 0"
          class="mat-h3 flex-row-center-center fxFlex"
        >
          {{ "ASSIGNMENTS.NO_EXPENSES" | translate }}
        </div>
      </div>

      <div
        mat-dialog-actions
        class="mt-8 p-8-buttons-theme flex-row-center-start"
      >
        <button mat-raised-button color="primary" (click)="onOK()" class="">
          {{ "GENERIC.OK" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
